// Jun-2026 — reusable client-side pagination for workspace tables.
import { useState } from "react";

export function usePager(items, perPage = 10) {
  const [page, setPage] = useState(1);
  const list = items || [];
  const pages = Math.max(1, Math.ceil(list.length / perPage));
  const cur = Math.min(page, pages);
  return { slice: list.slice((cur - 1) * perPage, cur * perPage),
           page: cur, pages, total: list.length, perPage, setPage };
}

export function Paginator({ pager, testid = "paginator" }) {
  if (pager.pages <= 1) return null;
  const from = (pager.page - 1) * pager.perPage + 1;
  const to = Math.min(pager.page * pager.perPage, pager.total);
  return (
    <div className="flex items-center justify-end gap-2 text-[11px] text-slate-600 px-2 py-1.5 border-t border-slate-100" data-testid={testid}>
      <span>{from}–{to} of {pager.total}</span>
      <button data-testid={`${testid}-prev`} disabled={pager.page <= 1} onClick={() => pager.setPage(pager.page - 1)}
        className="px-2 py-0.5 border border-slate-300 rounded disabled:opacity-40 font-bold hover:bg-slate-50">Prev</button>
      <span className="font-bold">Page {pager.page} / {pager.pages}</span>
      <button data-testid={`${testid}-next`} disabled={pager.page >= pager.pages} onClick={() => pager.setPage(pager.page + 1)}
        className="px-2 py-0.5 border border-slate-300 rounded disabled:opacity-40 font-bold hover:bg-slate-50">Next</button>
    </div>
  );
}
